import React from 'react';
import {classes, st} from './SkeletonSection.st.css';

interface SkeletonSectionProps {
  children: React.ReactNode;
  condensed?: boolean;
  className?: string;
}

export const SkeletonSection = ({children, condensed, className}: SkeletonSectionProps) => (
  <div className={st(classes.section, condensed ? classes.condensed : undefined, className)}>{children}</div>
);
